import React, {ReactNode} from "react";
import {Ribbon} from "./Ribbon";
import {Header} from "./Header";
import {useAppSelector} from "../../utils/Hooks";
import {useLocation, useNavigate} from "react-router-dom";

interface LoggedInViewProps {
    children: ReactNode;
    fullWidth: boolean
}

export const LoggedInView: React.FC<LoggedInViewProps> = ({children, fullWidth}) => {

    const location = useLocation();
    const navigate = useNavigate();

    const infoState = useAppSelector(state => state.info);

    const contentStyle = (fullWidth) ? {width: '100%'} : {};

    if ( !location.pathname.includes("/lock/unpaid") ) {
        if ((infoState?.unpaid?.length > 0 || infoState?.insurance?.length) && !location.pathname.includes("/orders/new/") && !location.pathname.includes("/orders/")) {
            sessionStorage.setItem('referrerUrl', location.pathname);
            navigate('/lock/unpaid');
            return null;
        }
    }

    const totalManaged = infoState?.managedLoadings?.reduce((sum, u) => sum + (u.managed || 0), 0) ?? 0

    const renderDayInfo = () => {
        if (fullWidth) {
            return null;
        }

        return (
            <div style={{position: 'absolute', marginTop: '100px', left: '1%'}}>
                <div>
                    <h2>Päringuid täna</h2>
                    <table className="data">
                        <thead>
                        <tr>
                            <th style={{width: '170px'}}>Logistik</th>
                            <th style={{width: '20px'}}>Päringuid</th>
                        </tr>
                        </thead>
                        <tbody>
                        {infoState?.inquiriesToday?.map(user => (
                            <tr key={'today' + user?.user?.id}>
                                <td>
                                    {user?.user?.firstname} {user?.user?.lastname}
                                </td>
                                <td>
                                    {user.queries_count}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <h2>
                        Hallatavad veod <span style={{fontSize: '12px'}}>(Kokku: {totalManaged})</span>
                    </h2>
                    <table className="data">
                        <tbody>
                        {infoState?.managedLoadings?.map(user => (
                            <tr key={'managed' + user?.checker?.id}>
                                <td>
                                    {user?.checker?.firstname} {user?.checker?.lastname}
                                </td>
                                <td>
                                    {user.managed}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <h2 style={{fontSize: '16px'}}>Hallatavad maanteeveod <span style={{fontSize: '12px'}}></span></h2>
                    <table className="data">
                        <tbody>
                        {infoState?.managedRoad?.map(user => (
                            <tr key={'rail' + user?.checker?.id}>
                                <td>
                                    {user?.checker?.firstname} {user?.checker?.lastname}
                                </td>
                                <td>
                                    {user.managed}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    {/*<h2 style={{fontSize: '16px'}}>Mere- ja raudteeveod <span
                        style={{fontSize: '12px'}}> (ohutu vahe 5)</span></h2>
                    <table className="data">
                        <tbody>
                        {infoState?.managedRailroadAndSea?.map(user => (
                            <tr key={'rail' + user?.checker?.id}>
                                <td>
                                    {user?.checker?.firstname} {user?.checker?.lastname}
                                </td>
                                <td>
                                    {user.managed}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>*/}
                </div>
            </div>
        );
    }

    return (
        <>
            {renderDayInfo()}
            <Ribbon/>
            <div id="wrap" style={contentStyle}>
                <Header/>
                <div id="content">
                    {children}
                </div>
            </div>
        </>
    );

}